import { atom } from 'jotai';

// コマンドパレット(⌘K / Ctrl+K)の開閉状態。
// MainPage の global keydown（開閉トグル）と本体 Dialog が共有する。既定は閉。
export const commandPaletteAtom = atom<boolean>(false);
